module.exports = __webpack_public_path__ + "static/saisons_-8078c41fbc1e04a39a13fb12b458fbcb.jpg";